import { useTheme, type SerializedStyles } from "@emotion/react";
import { useTranslation } from "react-i18next";

import { SvgFullscriptLogo, SvgFullscriptLogoDarkTextGreenLeaf } from "@shared/assets/logo";
import { l } from "@shared/locales/i18n";

interface Props {
  customCss?: SerializedStyles;
}

const PlatformLogo = ({ customCss }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const Logo = theme.theme === "dark" ? SvgFullscriptLogo : SvgFullscriptLogoDarkTextGreenLeaf;

  return (
    <Logo
      css={customCss}
      data-testid="fullscript-logo"
      aria-label={t(l.aviary.sidebarNav.fullscriptLogo)}
    />
  );
};

export { PlatformLogo };
